import { useEffect, useRef } from 'react';

/**
 * active の間だけ intervalMs ごとに poll を呼ぶ。見えないタブでは呼ばず、見えるようになったらすぐ1回呼ぶ。
 * 前の poll が終わるまで次を呼ばない（GET を重ねない）。
 */
export const useVisiblePolling = (active: boolean, poll: () => Promise<unknown>, intervalMs = 5000): void => {
  const inFlight = useRef(false);
  const latest = useRef(poll);
  latest.current = poll;

  useEffect(() => {
    if (!active) return undefined;
    const run = () => {
      if (document.visibilityState !== 'visible' || inFlight.current) return;
      inFlight.current = true;
      latest.current().finally(() => {
        inFlight.current = false;
      });
    };
    const timer = window.setInterval(run, intervalMs);
    const onVisible = () => {
      if (document.visibilityState === 'visible') run();
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, [active, intervalMs]);
};
